import React, { useEffect, useRef, useState } from "react";
import { LeftOutlined } from "@ant-design/icons";
import { getStoredItem, submitFormPart } from "./client";
import {
  Form,
  Input,
  Button,
  Radio,
  Select,
  DatePicker,
  Switch,
  Checkbox,
  Divider,
} from "antd";
import CustomFileUpload from "./CustomFileUpload";
import dayjs from "dayjs";
import SignaturePad from "./SignaturePad";

const { TextArea } = Input;

const FormPart = (props) => {
  const form = useRef(null);
  const [formDisabled, setFormDisabled] = useState(false);
  const [enableContinueBtn, setEnableContinueBtn] = useState(false);
  const [showAck, setShowAck] = useState(false);
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [signatureRequired, setSignatureRequired] = useState(false);
  const [signature, setSignature] = useState(false);
  const [ackChecked, setAckChecked] = useState(false);
  const [continueTxt, setContinueText] = useState("Continue");
  const progress = JSON.parse(localStorage.getItem("progress"));
  const form_id = progress ? progress.step : "1_1";

  useEffect(() => {
    form.current.resetFields();
    if (form_id === "1_10") {
      setSignature(signature);
      setShowSignaturePad(false);
    } else {
      setShowSignaturePad(false);
    }
    if (form_id === "3_3") {
      setContinueText("Submit Application");
    } else {
      setContinueText("Continue");
    }
    if (form_id === "3_1" || form_id === "3_2") {
      setShowAck(true);
      setFormDisabled(true);
      setEnableContinueBtn(true);
    } else {
      setShowAck(false);
      setFormDisabled(false);
      setEnableContinueBtn(false);
    }
    if (form_id === "3_4") {
      setEnableContinueBtn(true);
      setContinueText("Proceed to Payment");
    }
  }, [form_id, signature]);

  const enableContinue = () => {
    setEnableContinueBtn(!enableContinueBtn);
    setAckChecked(!ackChecked);
  };
  const goBack = (e) => {
    const prev_form_id = e.currentTarget.getAttribute("data-form-id");
    const data = {
      uid: getStoredItem("uid"),
      token: getStoredItem("token"),
      application_type: getStoredItem("applicationType"),
      form_id: prev_form_id,
      form_data: "",
      going_back: 1,
    };
    putForm(data, props);
    setSignature(false);
  };

  const onFinish = (values) => {
    if (showSignaturePad) {
      if (!signature) {
        setSignatureRequired(true);
        return false;
      }
    }
    setAckChecked(false);
    const data = {
      uid: getStoredItem("uid"),
      token: getStoredItem("token"),
      application_type: getStoredItem("applicationType"),
      form_id: form_id,
      form_data: values,
    };
    putForm(data, props);
  };

  return (
    <React.Fragment>
      <Form
        ref={form}
        scrollToFirstError={true}
        className="app-form"
        layout="vertical"
        colon={false}
        disabled={formDisabled}
        /*labelCol={{
              span: 10,
            }}*/
        wrapperCol={{
          span: 0,
        }}
        onFinish={onFinish}
        initialValues={props.formData}
      >
        {showAck && (
          <p className="confirm-review">
            Carefully review the information you have submitted and ensure
            correctness. If you notice any error or omission, go back to that
            section and correct it.
          </p>
        )}
        {props.form}
        {showAck && (
          <p className="confirm-review">
            I hereby confirm that I have carefully reviewed all form details
            provided and I confirm that the information provided is accurate to
            the best of my knowledge.
            <br />
            <Switch
              checked={ackChecked}
              disabled={!props.canGoBack}
              onChange={enableContinue}
              checkedChildren="Confirmed"
              unCheckedChildren="Click to Confirm"
            />
          </p>
        )}
        {showSignaturePad && (
          <SignaturePad
            signature={signature}
            setSignature={setSignature}
            form={form}
            signatureRequired={signatureRequired}
            setSignatureRequired={setSignatureRequired}
          />
        )}
        <p className="bottom-buttons">
          <Button
            data-form-id={props.previousFormId}
            type="default"
            disabled={!props.canGoBack}
            onClick={goBack}
          >
            <LeftOutlined /> Back
          </Button>
          <Button
            type="primary"
            disabled={enableContinueBtn}
            htmlType="submit"
            style={{ float: "right" }}
          >
            {continueTxt}
          </Button>
        </p>
      </Form>
    </React.Fragment>
  );
};

export const renderElements = (props) => {
  return (
    <React.Fragment>
      {props.map((parts, i) => {
        return (
          <React.Fragment key={i + "fp"}>
            <Divider plain>{parts.title ? <h3>{parts.title}</h3> : ""}</Divider>
            {parts.sections.map((section, j) => {
              if (!section.showUser) return [];
              return (
                <React.Fragment key={i + "-" + j + "-fp"}>
                  <Divider plain>
                    {section.title ? <h5>{section.title}</h5> : ""}
                  </Divider>
                  <p style={{ fontWeight: "bold" }}>{section.desc}</p>
                  {section.elements.map((element, k) => {
                    const desc =
                      element.desc === "" ? "" : <p>{element.desc}</p>;
                    return (
                      <React.Fragment key={i + "-" + k + "-" + j + "fp"}>
                        {getSectionElement(element)}
                        {desc}
                      </React.Fragment>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};
const getSectionElement = (elem) => {
  if (!elem.showUser) return;
  const elements = {
    text: <Input />,
    textarea: <TextArea autoSize={{ minRows: 5 }} />,
    p: <p>{elem.value}</p>,
    date: <DatePicker format="MM/DD/YYYY" />,
    radio: elem.type === "radio" ? renderRadio(elem) : "",
    select: elem.type === "select" ? renderSelect(elem) : "",
    check: elem.type === "check" ? <Checkbox></Checkbox> : "",
    signature: elem.type === "signature" ? <Input type="hidden" /> : "",
  };
  if (elem.type === "file-upload") {
    return <CustomFileUpload elem={elem} />;
  } else if (elem.type === "p") {
    return (
      <p style={{ textAlign: elem.align }}>
        {elem.value.replace("<br/>", <br />)}
      </p>
    );
  } else if (elem.type === "signature") {
    return (
      <Form.Item name={"elm_" + elem.id}>
        <Input type="hidden" />
      </Form.Item>
    );
  } else {
    return (
      <Form.Item
        rules={[
          {
            required: elem.required,
            message: "Please enter value for " + elem.label + "!",
          },
        ]}
        name={"elm_" + elem.id}
        label={elem.label}
        key={"elm_" + elem.id}
      >
        {elements[elem.type]}
      </Form.Item>
    );
  }
};

const renderRadio = (elem) => {
  return (
    <Radio.Group key={elem.id}>
      {elem.options.map((option, i) => {
        return (
          <Radio key={elem.id + "." + i} value={option.value}>
            {option.label}
          </Radio>
        );
      })}
    </Radio.Group>
  );
};
const renderSelect = (elem) => {
  return (
    <Select
      key={elem.id}
      showSearch
      mode={elem.multiple ? elem.multiple : ""}
      placeholder={elem.placeholder}
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      options={elem.options}
    />
  );
};

export const putForm = (dataIn, props) => {
  const validateDate = (testDate) => {
    const date_regex = /^\d{2}\/\d{2}\/\d{4}$/;
    return date_regex.test(testDate);
  };
  window.scrollTo(0, 0);
  props.setSpin(true);
  for (const [key, value] of Object.entries(dataIn.form_data)) {
    if (
      typeof value === "object" &&
      Array.isArray(value) === false &&
      value !== null
    ) {
      dataIn.form_data[key] = dayjs(value).format("MM/DD/YYYY");
    }
  }
  submitFormPart(dataIn)
    .then((res) => res.json())
    .then((data) => {
      const openMenuIndex = data.progress.step.split("_")[0] - 1;
      localStorage.setItem("form", JSON.stringify(data.form));
      localStorage.setItem("formData", JSON.stringify(data.form_data));
      for (const [key, value] of Object.entries(data.form_data)) {
        if (validateDate(value)) {
          data.form_data[key] = dayjs(data.form_data[key], "MM/DD/YYYY");
        }
      }
      localStorage.setItem(
        "previousFormId",
        JSON.stringify(data.previous_form_id)
      );
      localStorage.setItem("canGoBack", JSON.stringify(data.can_go_back));
      localStorage.setItem("progress", JSON.stringify(data.progress));
      localStorage.setItem("menu", JSON.stringify(data.menu));
      localStorage.setItem("openMenu", JSON.stringify("sub" + openMenuIndex));
      localStorage.setItem(
        "currentFormId",
        JSON.stringify(data.current_form_id)
      );
      if (data.current_form_id === "4_1") {
        props.setStripeClientSecret(data.form_data["client_secret"]);
        props.setStripePublicKey(data.form_data["public_key"]);
        localStorage.setItem(
          "stripeClientSecret",
          JSON.stringify(data.form_data["client_secret"])
        );
        localStorage.setItem(
          "stripePublicKey",
          JSON.stringify(data.form_data["public_key"])
        );
      }
      props.setForm(renderElements(data.form));
      props.setFormData(data.form_data);
      props.setProgress(data.progress);
      props.setMenu(data.menu);
      props.setActiveMenuItem("sub_sub" + data.progress.step);
      props.setCanGoBack(data.can_go_back);
      props.setPreviousFormId(data.previous_form_id);
      props.setOpenMenu(["sub" + openMenuIndex]);
      props.setCurrentFormId(data.current_form_id);
    })
    .finally((func) => {
      props.setSpin(false);
    });
};

export default FormPart;
